import isPropValid from '@emotion/is-prop-valid';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { border, color, compose, flexbox, layout, space } from 'styled-system';

const Anchor = styled('a', {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && !['width', 'height', 'display'].includes(prop),
})`
  ${css`
    text-decoration: none;
  `}
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}
  ${compose(border, color, flexbox, layout, space)}
`;

export default Anchor;
